import { defineStore } from 'pinia'

export const useAppStore = defineStore('app', {
  state: () => ({
    user: '',
    validationErrors: {} as Record<string, unknown>,
    isLoading: false,
  }),
  actions: {
    login(data: string) {
      this.user = data
    },
    logout() {
      this.user = ''
    },
    setValidationErrors(validationErrors: Record<string, unknown> | null) {
      this.validationErrors = validationErrors || {}
    },
    initialiseStore() {
      if (process.client) {
        const stored = localStorage.getItem('user')
        if (stored) this.user = stored
      }
    },
    toggleLoading(value: boolean) {
      this.isLoading = value
    },
  },
})
